<template>
    <v-container max-width="100%" style="margin-top: 2%">

        <v-dialog v-model="confirmResetDialog" persistent max-width="500">
            <v-card>
                <v-card-title class="headline">
                    <span style="color: #d60000">{{ $t('system.alert') }}</span>
                </v-card-title>
                <v-card-text>
                    <span style="color: #d60000">{{ this.mensagemResetDialog }}</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red accent-4" class="white--text" @click="confirmResetDialog = false">{{
                        $t('button.cancel')
                    }}</v-btn>
                    <v-btn color="red accent-4" class="white--text" @click="resetNotificacao()">{{
                        $t('button.confirmOk')
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-container>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <merus-data-table
                        :headers="tableHeadersNotificacoes"
                        :items="notificacoesFiltered"
                        :loading="loadingNotificacoes"
                        :loading-text="$t('system.messages.loading')"
                        :default-multi-sort="defaultSortNotificacoes"
                        item-key="id_notificacao"
                        cod-tabela="RESUMOOPERACAO__NOTIFICACOES"
                        :token="token"
                        @update:headers="headersNotificacoes = $event"
                        @update:displayedItems="displayedNotificacoesForExport = $event"
                        @click:row="(notif) => notifClicked(notif)"
                    >
                        <template v-slot:toolbar>
                            <CadastroToolbar
                                :title="$t('operationSummary.alerts')"
                                :token="token"
                                :items="displayedNotificacoesForExport !== null ? displayedNotificacoesForExport : notificacoesFiltered"
                                csv-title="alertasoperacao"
                                :csv-headers="tableHeadersNotificacoes"
                                :pdf-title="$t('operationSummary.operationNotification')"
                                :pdf-headers="tableHeadersNotificacoes"
                                pdf-filename="notificacoesoperacao"
                                hide-search
                            >
                                <template v-slot:extension>
                                    <v-autocomplete
                                        v-model="idTipoNotificacaoSelected"
                                        :items="tipoNotificacaoSelect"
                                        item-text="descricao_tipo_notificacao"
                                        item-value="id_tipo_notificacao"
                                        clearable
                                        multiple
                                        :label="$t('operationSummary.headersNotification.type')"
                                        style="margin-top: 20px; max-width: 320px;"
                                    ></v-autocomplete>
                                </template>
                                <template v-slot:add>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab
                                                @click="resetFiltros">
                                                <v-icon>mdi-reload</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ $t('operationSummary.resetFilters') }}</span>
                                    </v-tooltip>
                                </template>
                            </CadastroToolbar>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-icon class="mr-2" color="blue"
                                @click.stop="showResetNotificacaoDialog(item)">mdi-checkbox-marked-circle
                            </v-icon>
                        </template>
                    </merus-data-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <merus-data-table
                        :key="`linhas-${usaValidador}`"
                        :headers="tableHeadersLinhas"
                        :items="linhasFiltered"
                        :loading="loadingLinhas"
                        :loading-text="$t('system.messages.loading')"
                        :default-multi-sort="defaultSortLinhas"
                        show-select
                        v-model="linhasSelected"
                        item-key="id_linha"
                        cod-tabela="RESUMOOPERACAO__LINHAS"
                        :token="token"
                        @update:headers="headersLinhas = $event"
                        @update:displayedItems="displayedLinhasForExport = $event"
                    >
                        <template v-slot:item.descricao_todas_unidades="{ item }">
                            <span>{{ item.descricao_todas_unidades || item.descricao_unidade || '—' }}</span>
                        </template>

                        <template v-slot:toolbar>
                            <CadastroToolbar
                                :title="$t('operationSummary.linesInOperation.title')"
                                :token="token"
                                :items="linhasParaExportar"
                                csv-title="linhasemoperacao"
                                :csv-headers="tableHeadersLinhas"
                                :pdf-title="$t('operationSummary.linesInOperation.title')"
                                :pdf-headers="tableHeadersLinhas"
                                pdf-filename="linhasemoperacao"
                                hide-search
                            />
                        </template>
                    </merus-data-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <merus-data-table
                        :headers="tableHeadersGuias"
                        :items="guiasFiltered"
                        :loading="loadingGuias"
                        :loading-text="$t('system.messages.loading')"
                        :default-multi-sort="defaultSortGuias"
                        item-key="id_guia"
                        cod-tabela="RESUMOOPERACAO__GUIAS"
                        :token="token"
                        @update:headers="headersGuias = $event"
                        @update:displayedItems="displayedGuiasForExport = $event"
                    >
                        <template v-slot:item.guia_original="{ item }">
                            <span :style="getNumeroGuiaStyle(item)">{{ item.guia_original }}</span>
                        </template>

                        <template v-slot:item.numero_ordem="{ item }">
                            <span :style="getVeiculoGuiaStyle(item)">{{ item.numero_ordem }}</span>
                        </template>

                        <template v-slot:toolbar>
                            <CadastroToolbar
                                :title="guiasTitle"
                                :token="token"
                                :items="displayedGuiasForExport !== null ? displayedGuiasForExport : guiasFiltered"
                                csv-title="guiasemoperacao"
                                :csv-headers="tableHeadersGuias"
                                hide-search
                            >
                                <template v-slot:add>
                                    <ExportTablePdf
                                        :title="guiasTitle"
                                        :content="displayedGuiasForExport !== null ? displayedGuiasForExport : guiasFiltered"
                                        :headers="tableHeadersGuias"
                                        :subtitle="`Linhas: ${linhasSelected.map((l) => ' ' + l.cod_linha)}`"
                                        filename="guiasemoperacao"
                                    />
                                </template>
                            </CadastroToolbar>
                        </template>
                    </merus-data-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <merus-data-table
                        :key="`veiculos-${usaValidador}`"
                        :headers="tableHeadersVeiculos"
                        :items="veiculosFiltered"
                        :loading="loadingVeiculos"
                        :loading-text="$t('system.messages.loading')"
                        :default-multi-sort="defaultSortVeiculos"
                        item-key="id_veiculo"
                        cod-tabela="RESUMOOPERACAO__VEICULOS"
                        :token="token"
                        @update:headers="headersVeiculos = $event"
                        @update:displayedItems="displayedVeiculosForExport = $event"
                    >
                        <template v-slot:item.numero_ordem="{ item }">
                            <span :style="getVeiculoOrdemStyle(item)">{{ item.numero_ordem }}</span>
                        </template>

                        <template v-slot:item.cod_linha="{ item }">
                            <span :style="getVeiculoLinhaStyle(item)">{{ item.cod_linha }}</span>
                        </template>

                        <template v-slot:item.descricao_motorista_validador="{ item }">
                            <span :style="getVeiculoMotoristaStyle(item)">{{ item.descricao_motorista_validador }}</span>
                        </template>

                        <template v-slot:item.descricao_motorista_guia="{ item }">
                            <span :style="getVeiculoMotoristaStyle(item)">{{ item.descricao_motorista_guia }}</span>
                        </template>

                        <template v-slot:item.descricao_cobrador_validador="{ item }">
                            <span :style="getVeiculoCobradorStyle(item)">{{ item.descricao_cobrador_validador }}</span>
                        </template>

                        <template v-slot:item.descricao_cobrador_guia="{ item }">
                            <span :style="getVeiculoCobradorStyle(item)">{{ item.descricao_cobrador_guia }}</span>
                        </template>

                        <template v-slot:toolbar>
                            <CadastroToolbar
                                :title="veiculosTitle"
                                :token="token"
                                :items="displayedVeiculosForExport !== null ? displayedVeiculosForExport : veiculosFiltered"
                                csv-title="veiculosemoperacao"
                                :csv-headers="tableHeadersVeiculos"
                                hide-search
                            >
                                <template v-slot:add>
                                    <ExportTablePdf
                                        :title="veiculosTitle"
                                        :content="displayedVeiculosForExport !== null ? displayedVeiculosForExport : veiculosFiltered"
                                        :headers="tableHeadersVeiculos"
                                        filename="veiculosemoperacao"
                                        :subtitle="`${$tc('line.self', 1)}: ${linhasSelected.map((l) => ' ' + l.cod_linha)}`"
                                    />
                                </template>
                            </CadastroToolbar>
                        </template>
                    </merus-data-table>
                </v-col>
            </v-row>
        </v-container>

    </v-container>

</template>

<script>
import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import ExportTablePdf from "./ExportTablePdf.vue";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import translateDbField from "@/utils/translateDbField";

export default {
    components: {
        ExportTablePdf,
        MerusDataTable,
        CadastroToolbar,
    },
    data: () => ({
        token: null,
        user: null,
        usaValidador: false,
        confirmResetDialog: false,
        mensagemResetDialog: "",
        linhas: [],
        loadingLinhas: false,
        linhasSelected: [],
        headersLinhas: [],
        displayedLinhasForExport: null,
        veiculos: [],
        loadingVeiculos: false,
        headersVeiculos: [],
        displayedVeiculosForExport: null,
        guias: [],
        loadingGuias: false,
        headersGuias: [],
        displayedGuiasForExport: null,
        notificacoes: [],
        tipoNotificacaoSelect: [],
        loadingNotificacoes: false,
        idTipoNotificacaoSelected: [],
        headersNotificacoes: [],
        displayedNotificacoesForExport: null,
        notifSelected: null,
        notifToReset: null,
        recursos: [],
        empresasPermitidas: []
    }),
    computed: {
        defaultHeadersLinhas() {
            const col = (text, value, extras = {}) => ({
                text,
                value,
                sortable: true,
                filtrable: true,
                show: true,
                ...extras,
            });
            const todasColunas = [
                col(this.$t('operationSummary.linesInOperation.lineId'), "id_linha", { align: " d-none", filtrable: false, sortable: false }),
                col(this.$t('operationSummary.linesInOperation.unitDescription'), "descricao_todas_unidades"),
                col(this.$t('operationSummary.linesInOperation.lineName'), "nome_linha"),
                col(this.$t('operationSummary.linesInOperation.totalVehicles'), "total_veiculos"),
                col(this.$t('operationSummary.linesInOperation.totalOnlineVehicles'), "total_veiculos_online"),
                col(this.$t('operationSummary.linesInOperation.totalGpsOffline'), "total_gps_offline"),
                col(this.$t('operationSummary.linesInOperation.totalValidatorOffline'), "total_validador_offline", { ehValidador: true }),
            ];
            return todasColunas.filter((coluna) => !coluna.ehValidador || this.usaValidador);
        },
        tableHeadersLinhas() {
            return this.headersLinhas.length > 0 ? this.headersLinhas : this.defaultHeadersLinhas;
        },
        defaultSortLinhas() {
            return [
                { value: "nome_linha", options: { text: this.$t('routs.increasing'), value: 1 } },
            ];
        },
        defaultHeadersVeiculos() {
            const col = (text, value, extras = {}) => ({
                text,
                value,
                sortable: true,
                filtrable: true,
                show: true,
                ...extras,
            });
            const todasColunas = [
                col(this.$t('operationSummary.vehiclesInOperation.vehicleId'), "id_veiculo", { align: " d-none", filtrable: false, sortable: false }),
                col(this.$t('operationSummary.vehiclesInOperation.orderNumber'), "numero_ordem"),
                col(this.$t('operationSummary.vehiclesInOperation.validatorLine'), "cod_linha", { ehValidador: true }),
                col(this.$t('operationSummary.vehiclesInOperation.lineGuide'), "cod_linha_guia"),
                col(this.$t('operationSummary.vehiclesInOperation.driverValidator'), "descricao_motorista_validador", { ehValidador: true }),
                col(this.$t('operationSummary.vehiclesInOperation.guideDriver'), "descricao_motorista_guia"),
                col(this.$t('operationSummary.vehiclesInOperation.collectorValidator'), "descricao_cobrador_validador", { ehValidador: true }),
                col(this.$t('operationSummary.vehiclesInOperation.guideCollector'), "descricao_cobrador_guia"),
                col(this.$t('operationSummary.vehiclesInOperation.gpsStatus'), "gps_offline_extenso"),
                col(this.$t('operationSummary.vehiclesInOperation.validatorStatus'), "validador_offline_extenso", { ehValidador: true }),
            ];
            return todasColunas.filter((coluna) => !coluna.ehValidador || this.usaValidador);
        },
        tableHeadersVeiculos() {
            return this.headersVeiculos.length > 0 ? this.headersVeiculos : this.defaultHeadersVeiculos;
        },
        defaultSortVeiculos() {
            return [
                { value: "numero_ordem", options: { text: this.$t('routs.increasing'), value: 1 } },
            ];
        },
        defaultHeadersGuias() {
            const col = (text, value, extras = {}) => ({
                text,
                value,
                sortable: true,
                filtrable: true,
                show: true,
                ...extras,
            });
            return [
                col(this.$t('operationSummary.guidesInOperation.guideId'), "id_guia", { align: " d-none", filtrable: false, sortable: false }),
                col(this.$t('operationSummary.guidesInOperation.originalGuide'), "guia_original"),
                col(this.$t('operationSummary.guidesInOperation.lineCode'), "cod_linha"),
                col(this.$t('operationSummary.guidesInOperation.vehicleCode'), "numero_ordem"),
                col(this.$t('operationSummary.guidesInOperation.driverLicense'), "matricula_motorista"),
                col(this.$t('operationSummary.guidesInOperation.driverName'), "nome_motorista"),
                col(this.$t('operationSummary.guidesInOperation.collectorLicense'), "matricula_cobrador"),
                col(this.$t('operationSummary.guidesInOperation.collectorName'), "nome_cobrador"),
                col(this.$t('operationSummary.guidesInOperation.pickupDate'), "dt_pegada"),
                col(this.$t('operationSummary.guidesInOperation.dropoffDate'), "dt_largada"),
                col(this.$t('operationSummary.guidesInOperation.statusExtended'), "status_extenso"),
            ];
        },
        tableHeadersGuias() {
            return this.headersGuias.length > 0 ? this.headersGuias : this.defaultHeadersGuias;
        },
        defaultSortGuias() {
            return [
                { value: "data_hora_pegada", options: { text: this.$t('routs.decreasing'), value: -1 } },
            ];
        },
        defaultHeadersNotificacoes() {
            const col = (text, value, extras = {}) => ({
                text,
                value,
                sortable: true,
                filtrable: true,
                show: true,
                ...extras,
            });
            return [
                col(this.$t('operationSummary.headersNotification.notificationId'), "id_notificacao", { align: " d-none", filtrable: false, sortable: false }),
                col(this.$t('operationSummary.headersNotification.type'), "descricao_tipo_notificacao"),
                col(this.$t('operationSummary.headersNotification.date'), "dt_notificacao_extenso"),
                col(this.$t('operationSummary.headersNotification.line'), "nome_linha"),
                col(this.$t('operationSummary.headersNotification.vehicle'), "cod_veiculo"),
                col(this.$t('operationSummary.headersNotification.handled'), "reset_extenso"),
            ];
        },
        tableHeadersNotificacoes() {
            return this.headersNotificacoes.length > 0 ? this.headersNotificacoes : this.defaultHeadersNotificacoes;
        },
        defaultSortNotificacoes() {
            return [
                { value: "dt_notificacao_extenso", options: { text: this.$t('routs.decreasing'), value: -1 } },
            ];
        },
        linhasFiltered() {
            if (this.notifSelected) {
                return this.linhas.filter((l) => this.notifSelected.id_linha === l.id_linha);
            }

            return this.linhas;
        },
        linhasParaExportar() {
            const source = this.displayedLinhasForExport !== null ? this.displayedLinhasForExport : this.linhasFiltered;
            return source.map((l) => ({
                ...l,
                descricao_todas_unidades: l.descricao_todas_unidades || l.descricao_unidade || ''
            }));
        },
        veiculosFiltered() {
            if (this.notifSelected) {
                return this.veiculos.filter((v) => this.notifSelected.id_veiculo === v.id_veiculo);
            }

            let filtered = this.veiculos;
            if (this.linhasSelected.length > 0) {
                filtered = filtered.filter((v) => this.linhasSelected.findIndex((l) => l.id_linha === v.id_linha) !== -1);
            }

            return filtered;
        },
        veiculosTitle() {
            return this.linhasSelected.length > 0 ? this.$t('operationSummary.vehicleInSelectedLine') : this.$t('operationSummary.activeVehicles');
        },
        guiasFiltered() {
            if (this.notifSelected) {
                return this.guias.filter((g) => this.notifSelected.id_veiculo === g.id_veiculo);
            }

            let filtered = this.guias;
            if (this.linhasSelected.length > 0) {
                filtered = filtered.filter((g) => this.linhasSelected.findIndex((l) => l.id_linha === g.id_linha) !== -1);
            }

            return filtered;
        },
        guiasTitle() {
            return this.linhasSelected.length > 0 ? this.$t('operationSummary.guidesInSelectedLine') : this.$t('operationSummary.guidesActive');
        },
        notificacoesFiltered() {
            if (this.idTipoNotificacaoSelected.length > 0) {
                return this.notificacoes.filter((n) => this.idTipoNotificacaoSelected.includes(n.id_tipo_notificacao));
            }

            return this.notificacoes
        },
    },
    watch: {
        '$i18n.locale'() {
            this.headersLinhas = [];
            this.headersVeiculos = [];
            this.headersGuias = [];
            this.headersNotificacoes = [];
            this.initialize();
        },
        usaValidador() {
            this.headersLinhas = [];
            this.headersVeiculos = [];
        },
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    methods: {
        initialize() {
            this.populaRecursos();
            this.populaTiposNotificacao();
            this.buscarParametrosSetup();
        },
        buscarParametrosSetup() {
            apiController.request(apiController.endpoints.getallParametrossetup, {
                silent: true,
                onSuccess: (response) => {
                    if (response.data && response.data.length > 0) {
                        this.usaValidador = response.data[0].has_validador === 1;
                    }
                },
                onError: (e) => {
                    console.log("Erro ao buscar parâmetros: " + e.message);
                    this.usaValidador = false;
                },
            });
        },
        populaRecursos() {
            if (this.user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    silent: true,
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.populaEmpresasPermitidas();
                        this.populaLinhas();
                        this.populaVeiculos();
                        this.populaGuias();
                        this.populaNotificacoes();
                    },
                    onError: (e) => {
                        console.log("Response : " + e.message);
                        if (e.message == "Request failed with status code 401") {
                            EventBus.$emit('show-error', { error: e });
                        }
                    },
                });
            } else {
                apiController.request(apiController.endpoints.getRecursosusuario, {
                    params: { id: this.user.id_usuario },
                    silent: true,
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.populaEmpresasPermitidas();
                        this.populaLinhas();
                        this.populaVeiculos();
                        this.populaGuias();
                        this.populaNotificacoes();
                    },
                    onError: (e) => {
                        console.log("Response : " + e.message);
                        if (e.message == "Request failed with status code 401") {
                            EventBus.$emit('show-error', { error: e });
                        }
                    },
                });
            }
        },
        populaEmpresasPermitidas() {
            this.empresasPermitidas = this.recursos.filter((r) => r.id_empresa).map((rec) => {
                return rec.id_empresa
            });
        },
        populaLinhas() {
            this.loadingLinhas = true;
            apiController.request(apiController.endpoints.getLinhasoperacao, {
                silent: true,
                onSuccess: (response) => {
                    this.linhas = response.data;
                    this.loadingLinhas = false;
                },
                onError: (e) => {
                    this.loadingLinhas = false;
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        populaVeiculos() {
            this.loadingVeiculos = true;
            apiController.request(apiController.endpoints.getallVeiculosativos, {
                silent: true,
                onSuccess: (response) => {
                    this.veiculos = response.data.filter((v) => (v.id_linha_guia || v.id_linha) && this.empresasPermitidas.includes(v.id_empresa));
                    this.loadingVeiculos = false;
                },
                onError: (e) => {
                    this.loadingVeiculos = false;
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        populaGuias() {
            this.loadingGuias = true;
            apiController.request(apiController.endpoints.getGuiasemoperacao, {
                silent: true,
                onSuccess: (response) => {
                    this.guias = response.data.filter((g) => this.empresasPermitidas.includes(g.id_empresa));
                    this.loadingGuias = false;
                },
                onError: (e) => {
                    this.loadingGuias = false;
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        populaNotificacoes() {
            this.loadingNotificacoes = true;
            let dtinicio = new Date();
            dtinicio.setDate(dtinicio.getDate() - 1);

            let params = {
                dtinicio: this.getDataConsulta(dtinicio),
                dtfim: this.getDataConsulta(new Date())
            };

            apiController.request(apiController.endpoints.getNotificacoespordata, {
                data: params,
                silent: true,
                onSuccess: (response) => {
                    this.notificacoes = response.data
                        .filter((n) => !!n.tem_linha && n.reset === 0 && this.empresasPermitidas.includes(n.id_empresa))
                        .map((n) => ({
                            ...n,
                            descricao_tipo_notificacao: translateDbField(
                                n.translation_key,
                                n.descricao_tipo_notificacao
                            )
                        }));
                    this.loadingNotificacoes = false;
                },
                onError: (e) => {
                    this.loadingNotificacoes = false;
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        populaTiposNotificacao() {
            apiController.request(apiController.endpoints.getallTiposnotificacoes, {
                silent: true,
                onSuccess: (response) => {
                    this.tipoNotificacaoSelect = response.data
                        .filter((t) => t.id_tipo_notificacao >= 14)
                        .map((t) => ({
                            ...t,
                            descricao_tipo_notificacao: translateDbField(
                                t.translation_key,
                                t.descricao_tipo_notificacao
                            )
                        }));
                },
                onError: (e) => {
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        EventBus.$emit('show-error', { error: e });
                    }
                },
            });
        },
        getDataConsulta(dt) {
            var retorno = null;
            if (typeof dt == "string") {
                retorno =
                    dt.substring(6, 10) +
                    dt.substring(3, 5) +
                    dt.substring(0, 2) +
                    dt.substring(11, 13) +
                    dt.substring(14, 16) +
                    dt.substring(17);
            } else {
                var temp = dt.toLocaleString();
                retorno =
                    temp.substring(6, 10) +
                    temp.substring(3, 5) +
                    temp.substring(0, 2) +
                    temp.substring(12, 14) +
                    temp.substring(15, 17) +
                    temp.substring(18);
            }
            return retorno;
        },
        getVeiculoLinhaStyle(veiculo) {
            let guias = this.guias.filter((g) => g.id_veiculo === veiculo.id_veiculo);
            return guias.length !== 1 || guias[0].id_linha !== veiculo.id_linha ?
                "color: red; font-weight: bold;" :
                ""
        },
        getVeiculoMotoristaStyle(veiculo) {
            let guias = this.guias.filter((g) => g.id_veiculo === veiculo.id_veiculo);
            return guias.length !== 1 || guias[0].id_motorista !== veiculo.cod_motorista_veiculo ?
                "color: red; font-weight: bold;" :
                ""
        },
        getVeiculoCobradorStyle(veiculo) {
            let guias = this.guias.filter((g) => g.id_veiculo === veiculo.id_veiculo);
            return guias.length !== 1 || guias[0].id_cobrador !== veiculo.cod_cobrador_veiculo ?
                "color: red; font-weight: bold;" :
                ""
        },
        getVeiculoOrdemStyle(veiculo) {
            let guias = this.guias.filter((g) => g.id_veiculo === veiculo.id_veiculo);
            if (guias.length === 0) {
                return "color: purple; font-weight: bold;";
            }

            if (guias.length > 1) {
                return "color: red; font-weight: bold;";
            }

            return "";
        },
        getNumeroGuiaStyle(guia) {
            return this.guias.filter((g) => g.id_veiculo === guia.id_veiculo).length > 1 ? "color: red; font-weight: bold;" : "";
        },
        getVeiculoGuiaStyle(guia) {
            return this.veiculos.filter((v) => v.id_veiculo === guia.id_veiculo).length === 0 ? "color: red; font-weight: bold;" : "";
        },
        notifClicked(notif) {
            if (this.notifSelected) {
                if (this.notifSelected.id_notificacao === notif.id_notificacao) {
                    this.notifSelected = null;
                } else {
                    this.notifSelected = notif;
                }
            } else {
                this.notifSelected = notif;
            }
        },
        showResetNotificacaoDialog(notif) {
            this.mensagemResetDialog = this.$t('operation.confirmReset');
            this.notifToReset = notif;
            this.confirmResetDialog = true;
        },
        resetFiltros() {
            this.notifSelected = null;
            this.linhasSelected = [];
            this.idTipoNotificacaoSelected = [];
            this.initialize();
        },
        resetNotificacao() {
            this.confirmResetDialog = false;
            var params = { id_notificacao: this.notifToReset.id_notificacao };
            apiController.request(apiController.endpoints.updateNotificacao, {
                data: params,
                silent: true,
                onSuccess: () => {
                    this.populaNotificacoes();
                },
                onError: (e) => {
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        EventBus.$emit('show-error', { error: e });
                    }
                },
            });
        },
    }
}
</script>

<style></style>
